export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    headerAlign: 'center',
    field: 'visitDate',
    align: 'left',
    width: 150,
    title: that.$l('form_label_visitDate') || '拜访日期',
    sortable: true,
    sortType: 'String',
  },
  {
    headerAlign: 'center',
    field: 'scmName',
    align: 'center',
    width: 250,
    title: that.$l('form_label_scmName') || '供应商名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'visitTitle',
    align: 'left',
    minWidth: 200,
    title: that.$l('form_label_visitTitle') || '拜访目的',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'depName',
    align: 'center',
    width: 150,
    title: that.$l('form_label_depName') || '拜访业务部门',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'visitOwnerName',
    align: 'center',
    width: 120,
    title: that.$l('form_label_visitOwnerName') || '拜访负责人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'visitParticipant',
    align: 'center',
    minWidth: 200,
    title: that.$l('form_label_visitParticipant') || '拜访团队成员',
  },
  
]
